<template>
    <v-list dense style="width: 100%">
        <v-list-item-group
            v-model="activeLayerIndex"
            color="primary"
        >
            <v-list-item
                v-for="(layer, index) in activeLayers"
                :key="index"
            >
                <div class="publish-layer-status-list-item">
                    <element-state
                        :id="`publish-layer-status-list-item-${index}`"
                        :state="layer.state"
                        size="small"
                        colored-shadow
                    />
                    <v-list-item-title v-html="layer.text"/>
                    <v-icon v-if="layer.is_calendar">far fa-calendar-day</v-icon>
                </div>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script>
import elementState from './elementstate.vue';
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";

export default {
    name: 'PublishLayerStatusList',
    components: {
        VTooltipWrapper,
        elementState
    },
    props: {
        activeLayers: {
            type: Array,
            required: true,
        },
        value: {
            type: Number,
            default: null,
        },
    },
    computed: {
        translations() {
            return {
                tooltip: Lang.langGet('Some screens have unpublished content.')
            }
        },
        activeLayerIndex: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            },
        }
    },
}
</script>

<style scoped>
.publish-layer-status-list-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-block: 8px;
    justify-content: space-between;
    width: 100%;
}
</style>
